import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Field } from "formik";
import InputLabel from "@material-ui/core/InputLabel";

import useStyles from "assets/jss/material-dashboard-react/components/inputStyle";
import ErrorMessage from "components/ErrorMessage";
import { InputAdornment, IconButton, TextField } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import MaskedInput from "react-text-mask/dist/reactTextMask";

const CharAndNumInput = (props) => {
  const { inputRef, regex, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={(s) => Array.from(s).map(() => (regex ? regex : /[A-Za-z0-9]/i))}
      guide={false}
    />
  );
};

CharAndNumInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  regex: PropTypes.instanceOf(RegExp),
};

const RestrictedInput = (props) => {
  const { t } = useTranslation();
  const classesInner = useStyles();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const {
    label,
    name,
    required,
    // classes,
    labelClasses,
    errorMessage,
    password,
    disabledText,
    regex,
    ...rest
  } = props;
  return (
    <Field name={name}>
      {(props) => {
        const { field, meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classesInner.label, {
                [classesInner.error]:
                  errorMessage || (meta.error && meta.touched),
                [labelClasses]: labelClasses,
              })}
            >
              {t(label)}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <TextField
              // className={clsx(classesInner.root, {
              //   [classes]: classes,
              // })}
              name={name}
              type={password ? (showPassword ? "text" : "password") : "text"}
              error={Boolean(meta.touched) && Boolean(meta.error)}
              variant="outlined"
              {...rest}
              {...field}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
              disabled={
                disabledText ? disabledText.includes(field.value) : false
              }
              InputProps={
                password
                  ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    inputComponent: CharAndNumInput,
                  }
                  : { inputComponent: CharAndNumInput }
              }
              inputProps={{ regex: regex }}
            />
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};

RestrictedInput.propTypes = {
  label: PropTypes.string,
  labelClasses: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.string,
  name: PropTypes.string,
  errorMessage: PropTypes.array,
  field: PropTypes.object,
  meta: PropTypes.object,
  password: PropTypes.bool,
  disabledText: PropTypes.object,
  regex: PropTypes.instanceOf(RegExp),
};

export default RestrictedInput;
